<template>
    <div class="outer">

        <!-- 商务仓库管理 -->
        <el-dialog width="28%" :close-on-click-modal="false" title="出库" :visible="outVisable"
            @close="closeOutFormDialog">
            <el-form ref="outDataForm" :model="outDataForm" :rules="outDataRules" label-width="80px" style="width: 85%">
                <el-row :gutter="100">
                    <el-col :span="24">
                        <el-form-item label="项目名称" prop="outForChanceId" required>
                            <el-select v-model="outDataForm.outForChanceId" filterable placeholder="请选择"
                                style="width: 100%">
                                <el-option v-for="(item, i) in projectList" :key="i" :label="item.name" :value="item.id">
                                    {{ item.name }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="100">
                    <el-col :span="24">
                        <el-form-item label="出库数量" prop="goodsNum" required>
                            <el-input style="width: 100%" type="number" v-model="outDataForm.goodsNum"
                                placeholder="请输入"></el-input> 剩余数量: {{ this.outRustNum }}
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="100">
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remarks">
                            <el-input type="textarea" style="width: 100%" v-model="outDataForm.remarks"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="outVisable = false">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="outDataFormSubmit">确 定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog width="50%" :close-on-click-modal="false" title="出库信息" :visible="outboundVisable"
            @close="outboundVisable = false">
            <el-card style="margin-bottom: 30px;">
                <div class="flex-space-between" slot="header">
                    <span>货物基本信息</span>
                </div>

                <el-form ref="outForm" :model="outForm" label-width="120px">

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物名称" prop="goodsName">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsName"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="仓库类型" prop="category">
                                <el-input style="width: 100%" disabled v-model="outForm.category"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物分类" prop="goodsClassName">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsClassName"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物型号" prop="goodsType">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsType"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物单位" prop="goodsUnit">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsUnit" placeholder="">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="生产厂商" prop="manufacturer">
                                <el-input style="width: 100%" disabled v-model="outForm.manufacturer" placeholder="">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物品牌" prop="goodsBrand">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsBrand" placeholder="">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="总数量" prop="goodsNum">
                                <el-input style="width: 100%" disabled v-model="outForm.goodsNum" placeholder="">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="22">
                            <el-form-item label="货物配置" prop="goodsConfig">
                                <el-input type="textarea" style="width: 100%" disabled v-model="outForm.goodsConfig"
                                    placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </el-card>

            <el-card style="margin-bottom: 30px;">
                <div class="flex-space-between" slot="header">
                    <span>货物的采购单列表</span>
                </div>

                <el-table style="width: 100%;overflow: auto;" :row-class-name="tabRowClassName" :data="buyOrderList">
                    <el-table-column align="center" label="采购单编号" prop="purchaseNo">
                    </el-table-column>
                    <el-table-column align="center" label="项目名称" prop="projectName">
                    </el-table-column>
                    <el-table-column align="center" label="供应商名称" prop="supplierName">
                    </el-table-column>
                    <el-table-column align="center" label="剩余数量" width="80" prop="rustNum">
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="operate">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-truck" @click="outGoods(scope.row)"
                                v-if="scope.row.rustNum > 0">出库</el-button>
                            <el-button type="text" v-else>无需操作</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-dialog>
        <!-- 商务仓库管理 -->

        <!-- 行政仓库管理 -->
        <el-dialog width="35%" :close-on-click-modal="false" title="新建入库单" :visible="inVisable" @close="closeInDialog">
            <el-form ref="inForm" :model="inForm" :rules="inRules" label-width="130px" style="width: 89%;">

                <el-form-item label="入库来源" prop="inSource" required>
                    <el-select style="width: 100%" v-model="inForm.inSource" placeholder="请选择">
                        <el-option label="客户赠送" :value="2"></el-option>
                        <el-option label="私人库" :value="3"></el-option>
                        <el-option label="固定资产归还" :value="4"></el-option>
                        <el-option label="存量货物" :value="5"></el-option>
                        <el-option label="充值卡" :value="6"></el-option>
                        <el-option label="其他" :value="9"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="货物名称" prop="goodsName" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="inForm.goodsName" placeholder="选择货物后回显"></el-input>
                        <el-button style="margin-left: 10px;" type="primary"
                            @click="buyRequestGooodsVisable = true">选择货物</el-button>
                    </div>
                </el-form-item>

                <el-form-item label="货物类别" prop="goodsClassName" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="inForm.goodsClassName" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="货物品牌" prop="goodsBrand" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="inForm.goodsBrand" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>
                
                <el-form-item label="货物型号" prop="goodsType" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="inForm.goodsType" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>

                <template v-if="!inForm.goodsName.includes('充值卡')">
                    <el-form-item label="货物数量" prop="goodsNum" required>
                        <div class="flex-center">
                            <el-input style="width: 100%" type="number" v-model="inForm.goodsNum" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>

                    
                    <el-form-item label="货物单价(元)" prop="price" required>
                        <div class="flex-center">
                            <el-input style="width: 100%" type="number" v-model="inForm.price" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                </template>

                
                <template v-if="inForm.goodsName.includes('充值卡')">
                    <el-form-item label="充值金额" prop="goodsNum" required>
                        <div class="flex-center">
                            <el-input style="width: 100%" type="number" v-model="inForm.goodsNum" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                </template>
                

                <el-form-item
                :label="inForm.goodsName.includes('充值卡') ? '充值人部门' : '提供人部门'"
                prop="departmentId"
                label-width="130px"
                required
                >
                    <treeselect
                        :disable-branch-nodes="true"
                        v-model="inForm.departmentId"
                        :options="deptOptions"
                        :clearable="false"
                        :default-expand-level="2"
                        :normalizer="normalizer"
                        placeholder="请选择部门名称"
                        @select="handleSelect"
                    />
                </el-form-item>
                <el-form-item
                :label="inForm.goodsName.includes('充值卡') ? '充值人' : '提供人'"
                prop="providerUserId"
                label-width="130px"
                required
                >
                    <el-select
                    class="userSelect"
                    style="width: 100%"
                    v-model="inForm.providerUserId"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    clearable
                    >
                        <el-option
                        v-for="item in CeOptions"
                        :key="item.id"
                        :label="item.trueName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <div class="flex-center">
                        <el-input style="width: 100%" type="textarea" :rows="4" v-model="inForm.remarks"
                            placeholder="请输入"></el-input>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeInDialog">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitInOrder">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 行政仓库管理 -->

        <!-- 选择货物弹窗 -->
        <el-dialog width="55%" title="新建入库单-选择货物" :close-on-click-modal="false" v-if="buyRequestGooodsVisable"
            :visible="buyRequestGooodsVisable" @close="buyRequestGooodsVisable = false">
            <addGoods claimDialogType="edit" @checkGoods="checkGoods"/>
        </el-dialog>
        <!-- 选择货物弹窗 -->

        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="仓库分类" class="queryCol">
                    <el-select v-model="queryForm.category" @change="onSearch">
                        <el-option value="商务" label="商务仓库">商务仓库</el-option>
                        <el-option value="行政" label="行政仓库">行政仓库</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货物分类" class="queryCol">
                    <el-cascader style="width: 100%" v-model="queryForm.goodsClassCode"
                        :props="{ label: 'goodsClassName', value: 'goodsClassCode', emitPath: false, checkStrictly: true  }"
                        :options="classOptions" @change="onSearch" clearable @clear="onSearch">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="货物名称" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.goodsName"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>

            <div v-if="queryForm.category === '行政' && addPurchaseQX">
                <el-button type="primary" icon="el-icon-plus" @click="inVisable = true" >
                    新建入库单
                </el-button>
            </div>
            
        </div>

        <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
            style="width: 100%;height: 68vh;overflow: auto;" :data="tableData">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="货物名称" prop="goodsName">
            </el-table-column>
            <el-table-column align="center" label="仓库分类" prop="category">
                <template slot-scope="scope">
                    {{ scope.row.category }}仓库
                </template>
            </el-table-column>
            <el-table-column align="center" label="货物分类" prop="goodsClassName">
            </el-table-column>
            <el-table-column align="center" label="品牌" prop="goodsBrand">
            </el-table-column>
            <el-table-column align="center" label="货物型号" prop="goodsType">
            </el-table-column>
            <el-table-column align="center" label="生产厂商" prop="manufacturer">
            </el-table-column>
            <el-table-column align="center" label="货物配置" prop="goodsConfig">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" width="300">
                        <p>{{ scope.row.goodsConfig }}</p>
                        <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{scope.row.goodsConfig}}</p>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column align="center" label="平均价格(元)" prop="price">
            </el-table-column>
            <el-table-column align="center" label="总数量" prop="goodsNum">
            </el-table-column>
            <el-table-column align="center" label="货物单位" prop="goodsUnit">
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operate" v-if="queryForm.category === '商务' && classFlag === '1'">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-truck"
                        @click="outbound(scope.row)">出库</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination" style="display: flex; justify-content: space-between; margin-top: 20px">
            <div class="flex-center">
                <div style="margin-right: 20px;">货物种类数：{{ total }}</div>
                <div>总金额：{{ totalPrice }}</div>
            </div>
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 9999]" :current-page="page" background
                layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import addGoods from './addGoods.vue';
import { addInStore } from "@/api/goods/buyForm.js";
import { getGoodsClassList } from '@/api/goods/goodsBusiness.js';
import { getAllProject } from '@/api/goods/buyOrder.js';
import { queryWarehouse, queryOutInDetails, outGoodsFromWarehouse } from '@/api/goods/inventory.js';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
    data() {
        // 货物数量校验
        var checkGoodsNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入出库数量'));
            }
            if (value <= 0 || value.toString().includes('.')) {
                callback(new Error('请输入正整数'));
            } else if (value > this.outRustNum) {
                callback(new Error('出库数量大于剩余数量'));
            } else {
                callback();
            }
        }
        return {
            btnLoading: false, // 提交按钮是否禁用
            addPurchaseQX: this.$store.state.jxcSystemPermission.AdminRole(), // 新增采购权限 258 张楚君
            classFlag: '', // 货物类别
            deptOptions: [], // 部门选项
            CeOptions:[],  // 货物提供人下拉数据
            inRules:{
                price: [
                    { required: true, message: '请输入货物单价' }
                ],
                goodsClassName: [
                    { required: true, message: '请选择货物' }
                ],
                goodsBrand: [
                    { required: true, message: '请选择货物' }
                ],
                inSource: [
                    { required: true, message: '请选择入库来源' },
                ],
                goodsName: [
                    { required: true, message: '请选择货物' }
                ],
                goodsType: [
                    { required: true, message: '请选择货物' }
                ],
                goodsNum: [
                    { required: true, message: '请输入货物数量' }
                ],
                providerUserId: [
                    { required: true, message: '请选择提供人' }
                ],
                departmentId: [
                    { required: true, message: '请选择提供人部门' }
                ],
            },
            buyRequestGooodsVisable: false, // 选择货物弹窗显隐
            inForm: {
                goodsClassName: '', // 货物类别
                goodsBrand: '', // 货物品牌
                inSource: '', // 入库来源
                goodsName: '', // 货物名称
                goodsType: '', // 货物型号
                goodsNum: '', // 货物数量
                providerUserId: '', // 提供人
                remarks: '', // 备注
            }, // 入库表单
            inVisable: false, // 入库弹窗显隐
            isAdmin: sessionStorage.getItem('userRoleId') === '1' || sessionStorage.getItem('userRoleId') === '48' || sessionStorage.getItem('userRoleId') === '31', // 是否是行政（admin/48行政总监/31行政人员）
            outRustNum: 0, // 当前采购单剩余数量
            outVisable: false, // 出库表单弹窗显隐
            outDataForm: {
                outForChanceId: '',
                remarks: '',
                goodsNum: '',
            }, // 出库表单
            buyOrderList: [], // 货物明细采购单列表
            projectList: [], // 项目名称
            outboundVisable: false, // 出库弹窗显隐
            outForm: {},
            total: 0, // 总条目数
            pageSize: 10,
            page: 1,
            DialogTitle: '', // 弹窗标题
            tableData: [],
            loading: false,
            queryForm: {
                category: '',
            },
            classOptions: [],
            outDataRules: {
                outForChanceId: [
                    { required: true, message: '请选择项目名称' }
                ],
                goodsNum: [
                    { validator: checkGoodsNum, type: 'change' }
                ],
            }
        }
    },
    components: {
        addGoods,
        Treeselect
    },
    async created() {
        this.queryForm.category = this.isAdmin ? '行政' : '商务';
        await this.getTableData();
        let roleId = sessionStorage.getItem('userRoleId');
        if(roleId == 28){ // 商务采购货物分类
            this.classFlag = '1'
        }else if(roleId == 1 || roleId == 48 || roleId == 31){ // 行政采购货物分类（admin/行政总监/行政人员）
            this.classFlag = '2'
        }
        await this.getGoodsClassLists();
        this.getProjectList();
        let deptArr = await this.getDimTableDeptByIds([213, 214, 216]);
        this.deptOptions = deptArr.data.concat([]);
    },
    computed: {
        // 总库存数量
        totalNum() {
            let total = 0;
            this.tableData.forEach(item => {
                total += item.goodsNum;
            })
            return total;
        },
        //库存总价值
        totalPrice() {
            let total = 0;
            let unit = '元'
            this.tableData.forEach(item => {
                total += item.goodsNum * item.price;
            })
            //大于一万单位变成万元
            if(total >= 10000){
                total = total / 10000;
                total = total.toFixed(2);
                unit = '万元'
            }
            return total + unit;
        }
    },
    methods: {
        /** 转换部门数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                label: node.name,
                children: node.children,
            };
        },
        // 节点单击事件
        async handleSelect(node, instanceId) {
            this.inForm.providerUserId = '';
            let { data } = await getUserSelectByPage({
                condition: {
                    departmentId: node.id,
                },
                limit: 9999,
                page: 1,
            });
            this.CeOptions = data.records;
        },
        // 提交入库单
        submitInOrder(){
            this.$refs.inForm.validate((valid) => {
                if(valid){
                    this.btnLoading = true;
                    addInStore({
                        price: this.inForm.price,
                        inSource: this.inForm.inSource,
                        goodsName: this.inForm.goodsName,
                        goodsType: this.inForm.goodsType,
                        goodsCode: this.inForm.goodsCode,
                        goodsNum: this.inForm.goodsNum,
                        providerUserId: this.inForm.providerUserId,
                        remarks: this.inForm.remarks
                    }).then(res => {
                        this.btnLoading = false;
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '入库成功'
                            });
                            this.getTableData();
                            this.inVisable = false;
                        }
                    })
                }
            })
        },
        // 选择货物回调
        checkGoods(row) {
            this.inForm.goodsName = row.goodsName;
            if(this.inForm.goodsName.includes('充值卡')){
                this.inForm.price = 1;
            }
            this.inForm.goodsType = row.goodsType;
            this.inForm.goodsClassName = row.goodsClassName;
            this.inForm.goodsBrand = row.goodsBrand;
            this.inForm.goodsCode = row.goodsCode;
            this.buyRequestGooodsVisable = false;
        },
        closeInDialog() {
            this.$refs.inForm.resetFields();
            this.inForm = {
                inSource: '', // 入库来源
                goodsName: '', // 货物名称
                goodsType: '', // 货物型号
                goodsNum: '', // 货物数量
                providerUserId: '', // 提供人
                remarks: '', // 备注
            };
            this.inVisable = false;
        },
        closeOutFormDialog() {
            this.$refs.outDataForm.resetFields();
            this.outVisable = false;
        },
        tabRowClassName({ row }) {
            if (row.rustNum == 0) {
                return 'warning-row'
            }
            return ''
        },
        // 获取所有的项目列表
        getProjectList() {
            getAllProject().then(res => {
                if (res.code === 200) {
                    this.projectList = res.data;
                }
            })
        },
        outDataFormSubmit() {
            this.$refs.outDataForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    outGoodsFromWarehouse({
                        outForChanceId: this.outDataForm.outForChanceId,
                        purchaseNo: this.outDataForm.purchaseNo,
                        goodsCode: this.outForm.goodsCode,
                        goodsNum: this.outDataForm.goodsNum,
                        category: this.outForm.category,
                        remarks: this.outDataForm.remarks
                    }).then(res => {
                        this.btnLoading = false;
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '出库成功'
                            });
                            this.getTableData();
                            this.outboundVisable = false;
                            this.outVisable = false;
                        }
                    })
                }
            })
        },
        outGoods(row) {
            this.outDataForm.purchaseNo = row.purchaseNo;
            this.outRustNum = row.rustNum;
            this.outVisable = true;

        },
        // 出库弹窗
        outbound(row) {
            this.outForm = row;
            queryOutInDetails({
                "page": 1,
                "limit": 999,
                "outInFlag": null,
                "goodsCode": row.goodsCode
            }).then(res => {
                if (res.code === 200) {
                    let allList = []; // 入库列表
                    res.data.forEach(item => {
                        let flag = allList.find(jtem => jtem.purchaseNo === item.purchaseNo)
                        if (flag) {
                            flag.rustNum = flag.rustNum + (item.outInFlag * item.goodsNum);
                        } else {
                            item.rustNum = item.goodsNum * item.outInFlag;
                            allList.push(item);
                        }

                        this.buyOrderList = allList;
                    });
                    this.outboundVisable = true;
                }
            })
        },
        // 获取货物类别列表
        async getGoodsClassLists() {
            await getGoodsClassList({ classFlag: this.classFlag }).then(res => {
                if (res.code === 200) {
                    this.classOptions = res.data;
                }
            })
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.page = 1;
            this.pageSize = e;
            this.getTableData();
        },
        // 搜索
        onSearch() {
            console.log(this.queryForm);
            this.page = 1;
            this.getTableData();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.page = e;
            this.getTableData();
        },
        // 获取表格数据
        async getTableData() {
            this.loading = true
            await queryWarehouse({
                page: this.page,
                limit: this.pageSize,
                goodsName: this.queryForm.goodsName,
                category: this.queryForm.category,
                goodsClassCode: this.queryForm.goodsClassCode
            }).then(res => {
                if (res.code === 200) {
                    this.total = res.total;
                    this.tableData = res.data;
                    this.loading = false;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.outer {

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-table {
        ::v-deep .warning-row {
            display: none;
        }
    }

    .table {

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
